"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useDehydratedState = void 0;
var react_1 = require("@remix-run/react");
var deepmerge_1 = __importDefault(require("deepmerge"));
var useDehydratedState = function () {
    var matches = (0, react_1.useMatches)();
    var dehydratedState = matches
        .map(function (match) { var _a; return (_a = match.data) === null || _a === void 0 ? void 0 : _a.dehydratedState; })
        .filter(Boolean);
    return dehydratedState.length
        ? dehydratedState.reduce(function (accumulator, currentValue) { return (0, deepmerge_1["default"])(accumulator, currentValue); }, {})
        : undefined;
};
exports.useDehydratedState = useDehydratedState;
